import React from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import Checkbox from 'Common/Components/Checkbox/index';
import { updateCredential } from 'store/Credentials/actions';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_CREDENTIALS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const OwnedCell = ({ rowInfo, showSkeleton, field, isVulnDetail }) => {
  const value = get(rowInfo, `original.value.${field}`, '');
  const credential = get(rowInfo, 'original', {});
  const dispatch = useDispatch();
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_CREDENTIALS, PERMISSION_TYPES.PATCH));

  const handleClick = (e) => {
    if (allowedByRole) {
      e.stopPropagation();
      dispatch(updateCredential(credential, 'owned', !value, isVulnDetail));
    }
  };

  if (showSkeleton) return <Skeleton />;
  return (
    <Checkbox state={ value } onChange={ handleClick } disabled={ !allowedByRole } />
  );
};

OwnedCell.propTypes = {
  rowInfo: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  showSkeleton: PropTypes.bool
};

OwnedCell.defaultProps = {
  field: '',
  showSkeleton: false
};

export default OwnedCell;
